export default "__VITE_PUBLIC_ASSET__44cba025__"